import { render } from "./TravelPreferences.vue?vue&type=template&id=1fa4c753"
import script from "./TravelPreferences.vue?vue&type=script&lang=js"
export * from "./TravelPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__